import api from "./api";

const RESOURCE = "/api/municipio";
const RESOURCESTATE = "/api/estado";

const City = {
  searchCity: async (data, type = 'PERSON') =>
    await api.get(`${type === 'PERSON'? RESOURCE : RESOURCESTATE}/nome?descricao=${data}`),
};

export default City;
